import { Routes } from "@angular/router";
const ɵ0 = {
    breadCrumb: "Home",
    url: "",
    headerImgPath: "",
    skipBreadCrumb: true,
    hasCta: true,
    hasCarousel: true,
    title: "Mutual Funds Investment Online - SIP Investment | ITI MF Company India",
    meta: "ITI Mutual Fund provide different types of mutual funds in India, mutual fund calculators, Multi Cap Fund, Small Cap Fund, Long Term Equity Fund, Arbitrage Fund, Liquid Fund, etc. It is among India's leading mutual fund investment company.",
    keywords: "ITI mutual fund, mutual funds india, mutual funds, best mutual funds, mutual funds investment, sip investment, elss funds, best sip plans, best mutual fund, sip, mf"
};
const routes = [
    {
        path: "home",
        loadChildren: "./components/components.module#ComponentsModule",
        data: ɵ0,
    },
    { path: "", redirectTo: "home", pathMatch: "full" },
];
export class AppRoutingModule {
}
export { ɵ0 };
